import React, { ReactElement } from 'react';
import { RowNode } from 'ag-grid-community';
import { Tag } from './Tag';

export const Tags = ({ data: { tags } }: RowNode): ReactElement => (
  <>{tags && tags.map((tag: Tag) => <Tag key={tag.name} value={tag} />)}</>
);
